import React, { PropsWithChildren } from 'react';
import { Helmet } from 'react-helmet';

interface FacebookOGTagsProps {
  url: string;
  title: string;
  image: string;
  description: string;
  id?: string;
  price?: number | null;
  currency?: 'USD';
  availability?: 'available for order';
}

export const FacebookOGTags: React.FC<PropsWithChildren<FacebookOGTagsProps>> = ({
  url,
  title,
  image,
  description,
  id,
  price = null,
  currency,
  availability,
}) => {
  // @TODO handle trailing 0's after decimal, e.g. `19.90` => `19.9`
  const formattedPrice = `${price}`.includes('.') ? `${price}` : `${price}.00`;
  return (
    <Helmet>
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:image" content={image} />
      <meta property="og:description" content={description} />

      {currency && <meta property="og:price:currency" content={currency} />}
      {currency && <meta property="product:price:currency" content={currency} />}

      {price !== null && <meta property="og:price:amount" content={formattedPrice} />}
      {price !== null && <meta property="product:price:amount" content={formattedPrice} />}

      {price !== null && <meta property="product:condition" content="new" />}

      {price !== null && <meta property="product:brand" content="Yoga International" />}

      {id && <meta property="product:retailer_item_id" content={id} />}

      {availability && <meta property="product:availability" content={availability} />}
    </Helmet>
  );
};
